<template>
    <div class="ICP-filing">
        <div class="ICP-top">
            <span>杭州维学新知网络科技有限公司</span>
            <span style="cursor: pointer" @click="goGXBXT">浙ICP备2022007892号-1</span>
            <span style="cursor: pointer" @click="goGXBXT">工信部备案管理系统</span>
        </div>
        <div class="ICP-bottom">
            <a href="https://xyt.xcc.cn/getpcInfo?sn=1640605862508503040&language=CN&certType=8&url=*.myweixue.com"
                target="_blank" style="position: relative; display: inline-block; height: 38px" class="ssl_box">
                <div style="
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
              "></div>
                <embed src="https://program.xinchacha.com/web/1640605862508503040=*.myweixue.com.svg" width="103"
                    height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
            </a>
            <span class="ICP-bottom-item">Copyright©2018-2025 </span>
            <span>WeiXue</span>
            <span>All Rights Reserved</span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        goGXBXT() {
            window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
        },
    }
}
</script>

<style scoped lang="scss">
.ICP-filing {
    width: 100%;
    // height: 120px;
    background-color: #444546;
    color: #ffffff;
    // align-items: center;
    font-family: 'JjySmall';
    // line-height: 50px;
    padding: 20px 0;
    font-size: 17px;

    .ICP-top {
        margin-bottom: 10px;

        span {
            margin-right: 10px;
        }
    }

    .ICP-bottom {
        // margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        .ICP-bottom-item {
            margin-left: 8px;
        }

        span {
            font-size: 16px;
            margin-right: 10px;
        }
    }
}
</style>
